export default `
    <div class="wl-section--wrap wl-section--wrap__red">
      <div class="wl-section">
        <div class="wl-section--txt">
          <div class="wl-section--title">CAZINO LIVE</div>
          <div class="wl-section--subTxt">De oriunde te-ai afla, traieste acum experienta unui cazinou online.</div>
          <div class="wl-section--mainTxt">Fa prima depunere, iar noi te rasplatim cu un BONUS XXXL!</div>
          <div class="wl-section--secondaryTxt">Alege oricare din jocurile oferite de Favbet Casino Live pentru a juca pe bani reali.</div>
          <a href="../casino-live" class="wl-section--submitBtn">
            <span class="wl-section--animatedTxt">Accepta</span>
          </a>
          <a href="#" class="wl-section--detailsBtn">Afla mai multe</a>
        </div>
      </div>
    </div>
  `;
